var _rect, _path, _circle, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 15,
    fill: "#F2F2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9182 26.4067C47.1792 29.5445 47.3429 33.0164 46.3827 36.259C45.4225 39.5016 43.3947 42.3246 40.6285 44.2698C37.8622 46.2151 34.5198 47.1686 31.1435 46.9755C29.7201 46.8941 28.326 46.6109 27 46.1421M35.3334 17.375C32.2493 16.672 29.0157 16.9611 26.0979 18.2099C22.989 19.5405 20.4208 21.8827 18.8103 24.8563C18.537 25.3608 18.2941 25.8785 18.0818 26.4067C17.0432 28.9912 16.7405 31.8257 17.2256 34.5914C17.4069 35.6254 17.6951 36.6309 18.0818 37.5932",
    stroke: "#6A4BFF",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.6667,
    cy: 18.6666,
    r: 3.33333,
    stroke: "#6A4BFF",
    strokeWidth: 2.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.6667,
    cy: 45.3333,
    r: 3.33333,
    stroke: "#6A4BFF",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6671 28.685L31.3959 27.2349C31.7845 27.0838 32.2155 27.0838 32.6041 27.2349L36.3329 28.685C36.7351 28.8414 37 29.2287 37 29.6602V31.2492C37 33.4756 35.9721 35.5773 34.2147 36.9441C32.912 37.9573 31.088 37.9573 29.7853 36.9441C28.0279 35.5773 27 33.4756 27 31.2492V29.6602C27 29.2287 27.2649 28.8414 27.6671 28.685Z",
    stroke: "#6A4BFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.7fc4adbf009b35a0da0904ad09aac9d5.svg";
export { ForwardRef as ReactComponent };